import { render, staticRenderFns } from "./orderCell.vue?vue&type=template&id=af02be4a&scoped=true"
import script from "./orderCell.vue?vue&type=script&lang=js"
export * from "./orderCell.vue?vue&type=script&lang=js"
import style0 from "./orderCell.vue?vue&type=style&index=0&id=af02be4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af02be4a",
  null
  
)

export default component.exports